<template>
    <div class="box">
      
        <div class="box-header box-clearfix">
            <div class="box-title">
                <a href="javascript:;">Economic Calendar</a>
            </div>
        </div>
        <div class="box-body">
          <div class="economic-calendar">
            <div id="economicCalendarWidget"></div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
    new economicCalendar({ width: '100%', height: '100%', mode: 2 })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.economic-calendar {
  iframe {
    min-height: 650px;
  }
}
</style>
